<ng-container *transloco="let t">
  <app-header [title]="t('MAIN-PAGE.TITLE')" [withIcon]="true"/>
  <div class="main-page-container">
    <div>
      <button [disabled]="auditInProgress().length > 0" class="start-button" (click)="startAdHocAudit()">
        {{ t('COMMON.LABEL.START-ADHOC') }}
      </button>
      <p class="hint" *ngIf="auditInProgress().length > 0">{{ t('MAIN-PAGE.MAIN-BUTTON.HINT') }}</p>
    </div>
    <div class="assignments" *ngIf="auditInProgress().length > 0">
      <span>{{ t('MAIN-PAGE.ONGOING-AUDIT-TITLE') }}</span>
      <app-main-card *ngFor="let audit of auditInProgress()" [audit]="audit" (onDelete)="delete($event)"></app-main-card>
    </div>
    <div class="assignments">
      <span class="section-header">
        {{ t('ASSIGNMENT-PAGE.HEADER') }} {{upcomingAudits().length ? '(' + upcomingAudits().length + ')' : ''}}
      </span>
      <app-main-card *ngFor="let audit of upcomingAudits() | slice:0:3" [audit]="audit" (onDelete)="delete($event)"></app-main-card>
      <button class="see-all-button" *ngIf="upcomingAudits().length > 3" (click)="navigateToAll()">
        {{ t('MAIN-PAGE.ASSIGNMENTS.BUTTON-TEXT') }}
      </button>
      <div class="empty-audit-list" *ngIf="upcomingAudits().length === 0">
        <p class="subheadline-regular">
          {{ t('ASSIGNMENT-PAGE.SPACE-HOLDER') }}
        </p>
      </div>
    </div>
    <div class="assignments">
      <span class="section-header">{{ t('MAIN-PAGE.FINISHED-ASSIGNMENTS.TITLE') }}</span>
      <app-main-card *ngFor="let audit of finishedAudits() | slice:0:5" [audit]="audit" (onDelete)="delete($event)"></app-main-card>
      <div class="empty-audit-list" *ngIf="finishedAudits().length === 0">
        <p class="subheadline-regular" [innerHTML]="t('MAIN-PAGE.FINISHED-ASSIGNMENTS.SPACE-HOLDER-HTML')"></p>
      </div>
    </div>
  </div>
</ng-container>
